<template>
  <FormGroup :label="label" :inputId="idCalc" :errors="errorsCalc" :successes="successes">
    <textarea
      class="form-control"
      :rows="rows"
      :class="{ 'is-invalid': errorsCalc, 'is-valid': successes }"
      :data-test="testId"
      :id="idCalc"
      :name="name"
      :placeholder="placeholder"
      :value="modelValue"
      :disabled="disabled"
      @input="emitInput"
      @change="emitChange"
    />
  </FormGroup>
</template>

<script>
import FormGroup from "@/components/display/form/FormGroup";
import FormMixin from "@/components/display/form/FormMixin";

export default {
  name: "FormTextArea",
  components: {
    FormGroup,
  },
  mixins: [FormMixin],
  emits: ["change", "input", "update:modelValue"],
  props: {
    testId: String,
    modelValue: [String, Number],
    rows: {
      type: Number,
      default: 6,
    },
  },
  setup(props, { emit }) {
    const emitChange = (e) => emit("change", e.target.value);
    const emitInput = (e) => {
      const value = e.target.value;
      emit("input", value);
      emit("update:modelValue", value);
    };

    return {
      emitChange,
      emitInput,
    };
  },
};
</script>

<style lang="scss" scoped></style>
